import React from 'react';
import PropTypes from 'prop-types';

import * as S from '../styles.ts';

export function NeutralFace({ inactive, disabled }) {
    return (
        <S.SVGContainer $disabled={disabled} viewBox="0 0 1000 1000">
            <S.Background
                $active={!inactive}
                fill="#FF6900"
                d="M543.1 42.4c252.9 0 457.9 205 457.9 457.9S796 958.2 543.1 958.2 85.2 753.2 85.2 500.3s205-457.9 457.9-457.9z"
            />
            <S.Shape
                fill="#353535"
                d="M675.4 663.1c0 8.3-6.7 15-15 15H277.1c-8.3 0-15-6.7-15-15s6.7-15 15-15h383.2c8.3 0 15.1 6.7 15.1 15zm266.9-162.8c0 259.1-210.5 469.7-469.6 469.7S3 759.4 3 500.3 213.5 30.6 472.6 30.6s469.7 210.6 469.7 469.7zm-23.5 0c0-245.8-200.5-446.2-446.3-446.2S26.4 254.5 26.4 500.3s200.5 446.2 446.3 446.2 446.1-200.4 446.1-446.2z"
            />
        </S.SVGContainer>
    );
}

NeutralFace.propTypes = {
    inactive: PropTypes.bool,
    disabled: PropTypes.bool,
};

NeutralFace.defaultProps = {
    inactive: false,
    disabled: false,
};

export default NeutralFace;
